import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BaseRoutes from "./routes/BaseRoutes/BaseRoutes";
import { ToastContainer } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import "./assests/scss/index.scss";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path={`/*`} element={<BaseRoutes />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
